import { actionCreatorFactory } from "typescript-fsa";

import { Identifier } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";

import { TextbausteinImportData } from "./textbausteineTypeGuard";

const factory = actionCreatorFactory("MODULF");

export const importTextbausteine = factory<ImportTextbausteinePayload>("IMPORT_TEXTBAUSTEINE");

export interface ImportTextbausteinePayload {
	nodeIdentifier: Identifier;
	activityId: string;
	textbausteinImportData: TextbausteinImportData;
}
